import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ProductInput from "../ProductInput.vue";
export default {
  name: "Product",
  components: {
    ProductInput: ProductInput
  },
  data: function data() {
    return {
      productItem: _objectSpread(_objectSpread({}, this.product), {}, {
        featured: +this.product.featured
      }),
      showEditPopup: false
    };
  },
  watch: {
    product: function product(newProduct) {
      this.productItem = newProduct;
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    activeCategory: {
      type: Object,
      required: true
    },
    activeSubCategory: {
      type: Object,
      required: false
    }
  },
  methods: {
    productUpdated: function productUpdated(resource, category, subCategory) {
      var _this$activeCategory, _this$activeSubCatego;

      if (category.id === ((_this$activeCategory = this.activeCategory) === null || _this$activeCategory === void 0 ? void 0 : _this$activeCategory.id) && (subCategory === null || subCategory === void 0 ? void 0 : subCategory.id) === ((_this$activeSubCatego = this.activeSubCategory) === null || _this$activeSubCatego === void 0 ? void 0 : _this$activeSubCatego.id)) {
        this.productItem = _objectSpread(_objectSpread({}, resource), {}, {
          featured: +resource.featured
        });
      } else {
        this.$emit("productCategoryChanged", resource, category, {
          current: this.activeSubCategory,
          target: subCategory
        });
      }
    },
    remove: function remove() {
      var _this = this;

      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "\u062D\u0630\u0641 \u0645\u062D\u0635\u0648\u0644",
        text: "\u0627\u0632 \u062D\u0630\u0641 \u0645\u062D\u0635\u0648\u0644 \"".concat(this.product.title, "\" \u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u062F\u0627\u0631\u06CC\u062F\u061F"),
        acceptText: "بلی",
        cancelText: "خیر",
        accept: function accept() {
          _this.$emit("delete");
        }
      });
    }
  }
};